module.exports = __webpack_public_path__ + "static/media/pg06.e8c15632.jpg";